module.exports = __webpack_public_path__ + "media/images/partner-hand-a09f7578.png";